module.exports = __webpack_public_path__ + "static/media/drag-drop.4b441365.svg";